import styled from 'styled-components';

export const SublistContainer = styled.div<{
  $minimalIndentation?: boolean;
  $maximalIndentation?: boolean;
}>`
  padding-left: ${({ theme, $minimalIndentation, $maximalIndentation }) =>
    theme.spacing($minimalIndentation ? 3 : $maximalIndentation ? 7 : 6)};
`;
